import React, { useState, useEffect } from "react";
import { Button, Form, Modal, Grid } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { migratecollections } from "actions/collections"
import styles from "./collections.module.scss";
import cx from 'classnames'
import _ from 'lodash';

const MyVerticallyCenteredModal = (props) => {

  const users = useSelector((state) => _.get(state, "users.items"));
  const loading = useSelector((state) => _.get(state, "users.loading"));
  const [userData, setUserData] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    props.setLoading(loading);
  }, [loading]);



  const handleClick = () => {
    dispatch(
      migratecollections({
        filters: { userId: userData, collectionId: props.selectedCollectionId },
      })
    );
    props.onHide()

  }

 let options = []
 users?.map((item) => {
    if(item.name !== props.selectedTransferName && item.enabled)
    {
      options = [...options,{
        key: item.id,
        text: item.name,
        value: item.id,}]
    }
    return ;
 })

  const handleCancel = () => {
    props.onHide()
  };


  return (

    <>
      <div style={{ width: "400px" }}>
        <Modal open={props.show}
          size="tiny"
          onClose={props.onHide}
          className={cx(styles.create)}
        >
          <Grid.Row>
            <Grid.Column >

              <Form.Dropdown className={cx(styles.dropdown)}
                placeholder="Users"

                onChange={(e, data) => setUserData(data.value)}

                selection
                options={options}
              ></Form.Dropdown>
            </Grid.Column>
          </Grid.Row>


          <Modal.Actions className={cx("buttons", styles.actionButtons)}>
            <Button className="transforming" disabled={loading} onClick={handleClick}>Transfer</Button>
            <Button className="cancel" onClick={handleCancel}>Cancel</Button>
          </Modal.Actions>


        </Modal>
      </div >
    </>
  );
};

export default MyVerticallyCenteredModal;
